// @ts-nocheck
import {
    MONITORING_SPORTS_RECEIVED,
    MONITORING_EVENTS_RECEIVED,
    MONITORING_EVENT_RECEIVED,
    MONITORING_SPORTS_FETCHING,
    MONITORING_EVENTS_FETCHING,
    MONITORING_EVENT_FETCHING,
    MONITORING_LEAGUE_REMOVED,
    MONITORING_EVENTS_UPDATED,
    MONITORING_EVENT_HISTORY_RECEIVED,
    MONITORING_EVENT_HISTORY_CHANGED,
    MONITORING_RISK_DETAILS_CHANGED,
    MONITORING_BET_INFORMATION_CHANGED,
    MONITORING_BET_INFORMATION_RECEIVED,
    MONITORING_DATES_CHANGED,
    EVENT_MARKETS_UPDATED,
    MONITORING_FILTERS_CHANGED,
    SETTLEMENT_CHANGED,
    SETTLEMENT_FETCHING_CHANGED,
    MARKETS_FILTERS_CHANGED,
    MARKET_FETCHING_CHANGED,
    MARKET_DATA_CHANGED,
    MARKET_DATA_CLEARED,
    MONITORING_SET_SELECTED_SPORTID,
    MONITORING_OUTRIGHT_EVENTS_FETCHING,
    MONITORING_OUTRIGHT_EVENTS_RECEIVED,
    MONITORING_OUTRIGHT_EVENTS_UPDATED,
    MONITORING_OUTRIGHT_LEAGUE_REMOVED,
    MONITORING_RISK_DETAILS_RECEIVED,
} from '../types';
import MonitoringService from 'services/MonitoringService';
import { notification } from 'antd';
import { EVENT_RISK_STATUS } from 'utils/constants';
import { updateSocketContext } from './socket';

export const getSportsMonitoring = filters => async dispatch => {
    dispatch(setMonitoringSportsLoading(true));

    const data = await MonitoringService.getSports(filters);

    if (data?.items) {
        dispatch(setMonitoringSports(data.items));
    }

    dispatch(setMonitoringSportsLoading(false));
};

export const fetchEventList = filters => async (dispatch, getStore) => {
    const store = getStore();
    const dates = store.monitoring.dateRange;

    const data = await MonitoringService.getEvents({
        ...filters,
        ...dates,
        channel: 'ONLINE',
    });

    return data;
};

export const getEventList = filters => async dispatch => {
    dispatch(setMonitoringEventsLoading(true));

    const data = await dispatch(fetchEventList(filters));

    if (data?.items) {
        dispatch(setMonitoringEvents(data.items));
    }

    dispatch(setMonitoringEventsLoading(false));
};

export const updateEventList = filters => async dispatch => {
    dispatch(setMonitoringEventsLoading(true));

    const data = await dispatch(fetchEventList(filters));

    if (data?.items) {
        dispatch(updateMonitoringEvents(data.items));
    }

    dispatch(setMonitoringEventsLoading(false));
};

export const getOutrightEventList = filters => async dispatch => {
    dispatch(setMonitoringOutrightEventsLoading(true));

    const data = await dispatch(fetchEventList(filters));

    if (data?.items) {
        dispatch(setMonitoringOutrightEvents(data.items));
    }

    dispatch(setMonitoringOutrightEventsLoading(false));
};

export const updateOutrightEventList = filters => async dispatch => {
    dispatch(setMonitoringOutrightEventsLoading(true));

    const data = await dispatch(fetchEventList(filters));

    if (data?.items) {
        dispatch(updateMonitoringOutrightEvents(data.items));
    }

    dispatch(setMonitoringOutrightEventsLoading(false));
};

export const getCurrentEvent = filters => async dispatch => {
    dispatch(setMonitoringEventLoading(true));

    const data = await MonitoringService.getEventMarkets(filters);

    if (data.item) {
        dispatch(
            setCurrentEvent({
                id: filters.eventId,
                ...data.item,
            }),
        );
    }

    dispatch(setMonitoringEventLoading(false));
};

export const setCurrentEvent = event => ({
    type: MONITORING_EVENT_RECEIVED,
    payload: event,
});

export const saveMonitoringDateRange = dates => dispatch => {
    dispatch(updateSocketContext({ dates }));
    dispatch(setMonitoringDates(dates));
};

export const saveMonitoringFilters = filters => ({
    type: MONITORING_FILTERS_CHANGED,
    payload: filters,
});

export const setMonitoringEventLoading = isFetching => ({
    type: MONITORING_EVENT_FETCHING,
    payload: isFetching,
});

export const updateEventMarkets = data => ({
    type: EVENT_MARKETS_UPDATED,
    payload: data,
});

export const setMonitoringSportsLoading = isFetching => ({
    type: MONITORING_SPORTS_FETCHING,
    payload: isFetching,
});

export const setMonitoringEventsLoading = isFetching => ({
    type: MONITORING_EVENTS_FETCHING,
    payload: isFetching,
});

export const setMonitoringOutrightEventsLoading = isFetching => ({
    type: MONITORING_OUTRIGHT_EVENTS_FETCHING,
    payload: isFetching,
});

export const removeMonitoringLeague = leagueId => ({
    type: MONITORING_LEAGUE_REMOVED,
    payload: leagueId,
});

export const removeMonitoringOutrightLeague = leagueId => ({
    type: MONITORING_OUTRIGHT_LEAGUE_REMOVED,
    payload: leagueId,
});

export const clearMonitoringEvents = () => dispatch => {
    dispatch(setMonitoringEvents([]));
    dispatch(setMonitoringOutrightEvents([]));
};

export const freezeEvent = data => async dispatch => {
    const { isFrozen, ...body } = data;

    let response;

    if (isFrozen) response = await MonitoringService.unfreezeEvent(body);
    else response = await MonitoringService.freezeEvent(body);

    if (response.info.success) {
        notification.success({
            message: response.data?.item || 'Match freeze status changed!',
        });
    } else {
        notification.error({
            message: 'Freeze/Unfreeze Failed!',
        });
    }

    return response;
};

export const freezeRegularMatch =
    ({ isFrozen, resourceType, eventId, tournamentId, viewEvent, channel }) =>
    async (dispatch, getStore) => {
        let response = await dispatch(freezeEvent({ isFrozen, resourceType, eventId, channel }));

        if (response.info.success) {
            const store = getStore();

            // if the action is dispatched from view event page, we need to update all its markets as well, hence the if statement.
            // on the main monitoring page, we just update the event in the event list
            if (viewEvent) {
                const riskStatusId = isFrozen ? EVENT_RISK_STATUS.UN_FREEZE : EVENT_RISK_STATUS.FREEZE;
                const currentEvent = store.monitoring.currentEvent;

                const newEvent = {
                    ...currentEvent,
                    riskStatusId,
                    markets: currentEvent.markets?.map(market => ({
                        ...market,
                        riskStatusId: isFrozen ? EVENT_RISK_STATUS.UN_FREEZE : EVENT_RISK_STATUS.FREEZE,
                    })),
                };

                dispatch(setCurrentEvent(newEvent));
            } else {
                const newEvents = getNewEventListAfterAction({
                    events: store.monitoring.events.list,
                    tournamentId,
                    eventId,
                    fieldKey: 'riskStatus',
                    fieldValue: isFrozen ? EVENT_RISK_STATUS.UN_FREEZE : EVENT_RISK_STATUS.FREEZE,
                });
                dispatch(setMonitoringEvents(newEvents));
            }
        }
    };

export const freezeOutrightMatch =
    ({ isFrozen, resourceType, eventId, viewEvent, channel }) =>
    async (dispatch, getStore) => {
        let response = await dispatch(freezeEvent({ isFrozen, resourceType, eventId, channel }));

        if (response.info.success) {
            const store = getStore();

            // if the action is dispatched from view event page, we need to update all its markets as well, hence the if statement.
            // on the main monitoring page, we just update the event in the event list
            if (viewEvent) {
                // const riskStatusId = isFrozen ? EVENT_RISK_STATUS.UN_FREEZE : EVENT_RISK_STATUS.FREEZE;
                // const currentEvent = store.monitoring.currentEvent;
                //
                // const newEvent = {
                //     ...currentEvent,
                //     riskStatusId,
                //     markets: currentEvent.markets?.map(market => ({
                //         ...market,
                //         riskStatusId: isFrozen ? EVENT_RISK_STATUS.UN_FREEZE : EVENT_RISK_STATUS.FREEZE,
                //     })),
                // };
                //
                // dispatch(setCurrentEvent(newEvent));
            } else {
                const newEvents = getNewOutrightEventListAfterAction({
                    events: store.monitoring.outrightEvents.list,
                    eventId,
                    changedFields: {
                        riskStatus: isFrozen ? EVENT_RISK_STATUS.UN_FREEZE : EVENT_RISK_STATUS.FREEZE,
                    },
                });
                dispatch(setMonitoringOutrightEvents(newEvents));
            }
        }
    };

export const cancelMatch = data => async dispatch => {
    const response = await MonitoringService.cancelEvent(data);

    if (response.info.success) {
        notification.success({
            message: response.data?.item || 'Match cancelled!',
        });
    } else {
        notification.error({
            message: 'Match Cancelled!',
        });
    }

    return response;
};

export const cancelRegularMatch =
    ({ eventId, resourceType, tournamentId, channel }) =>
    async (dispatch, getStore) => {
        const response = await dispatch(cancelMatch({ resourceType, eventId, channel }));

        if (response.info.success) {
            const store = getStore();
            const newEvents = getNewEventListAfterAction({
                events: store.monitoring.events.list,
                tournamentId,
                eventId,
                fieldKey: 'riskStatus',
                fieldValue: EVENT_RISK_STATUS.CANCEL,
            });
            dispatch(setMonitoringEvents(newEvents));
        }
    };

export const cancelOutrightMatch =
    ({ eventId, resourceType, channel }) =>
    async (dispatch, getStore) => {
        const response = await dispatch(cancelMatch({ resourceType, eventId, channel }));

        if (response.info.success) {
            const store = getStore();
            const newEvents = getNewOutrightEventListAfterAction({
                events: store.monitoring.outrightEvents.list,
                eventId,
                changedFields: {
                    riskStatus: EVENT_RISK_STATUS.CANCEL,
                },
            });
            dispatch(setMonitoringOutrightEvents(newEvents));
        }
    };

export const changeMatchMbn =
    ({ eventId, competitionTypeId, mbn, channel }) =>
    async (dispatch, getStore) => {
        const response = await MonitoringService.changeMbn({ eventId, competitionTypeId, mbn, channel });

        if (response.info.success) {
            notification.success({
                message: response.data?.item || 'Event MBN changed successfully!',
            });

            const store = getStore();
            const currentEvent = store.monitoring.currentEvent;
            const newEvent = {
                ...currentEvent,
                mbn,
                markets: currentEvent.markets?.map(market => ({
                    ...market,
                    mbn,
                })),
            };

            dispatch(setCurrentEvent(newEvent));
        } else {
            notification.error({
                message: 'MBN Change Failed!',
            });
        }
    };

export const freezeMarket =
    ({ isFrozen, ...data }) =>
    async (dispatch, getStore) => {
        let response;
        if (isFrozen) response = await MonitoringService.unfreezeMarket(data);
        else response = await MonitoringService.freezeMarket(data);

        if (response.info.success) {
            notification.success({
                message: response.data?.item || 'Market freeze status changed!',
            });

            const store = getStore();
            const currentEvent = store.monitoring.currentEvent;

            const newEvent = {
                ...currentEvent,
                markets: currentEvent.markets.map(market => {
                    if (market.id !== data.marketId) return market;
                    else
                        return {
                            ...market,
                            riskStatusId: isFrozen ? EVENT_RISK_STATUS.UN_FREEZE : EVENT_RISK_STATUS.FREEZE,
                        };
                }),
            };

            dispatch(setCurrentEvent(newEvent));
        } else {
            notification.error({
                message: 'Freeze Failed!',
            });
        }
    };

export const freezeOutcome =
    ({ isFrozen, ...data }) =>
    async (dispatch, getStore) => {
        let response;
        if (isFrozen) response = await MonitoringService.unfreezeOutcome(data);
        else response = await MonitoringService.freezeOutcome(data);
        if (response.info.success) {
            notification.success({
                message: response.data?.item || 'Outcome freeze status changed!',
            });
            const store = getStore();
            const currentEvent = store.monitoring.currentEvent;
            const newEvent = {
                ...currentEvent,
                markets: currentEvent.markets.map(market => {
                    if (market.id !== data.marketId) return market;
                    else
                        return {
                            ...market,
                            outcomes: market.outcomes.map(outcome => {
                                if (outcome.outcomeRefId !== data.outcomeRefId) return outcome;
                                else
                                    return {
                                        ...outcome,
                                        riskStatusId: isFrozen ? EVENT_RISK_STATUS.UN_FREEZE : EVENT_RISK_STATUS.FREEZE,
                                    };
                            }),
                        };
                }),
            };
            dispatch(setCurrentEvent(newEvent));
        } else {
            notification.error({
                message: 'Freeze Failed!',
            });
        }
    };

export const changeMarketMbn = data => async (dispatch, getStore) => {
    const response = await MonitoringService.changeMbn(data);

    if (response.info.success) {
        notification.success({
            message: response.data?.item || 'Market MBN changed successfully!',
        });

        const store = getStore();
        const currentEvent = store.monitoring.currentEvent;
        const newEvent = {
            ...currentEvent,
            markets: currentEvent.markets.map(market => {
                if (market.id !== data.marketId) return market;
                else return { ...market, mbn: data.mbn };
            }),
        };

        dispatch(setCurrentEvent(newEvent));
    } else {
        notification.error({
            message: 'MBN Change Failed!',
        });
    }
};

export const changeMarketMaxWinAmount = data => async (dispatch, getStore) => {
    const response = await MonitoringService.changeMaxWinAmount(data);

    if (response.info.success) {
        notification.success({
            message: response.data?.item || 'Market Max Win Amount changed successfully!',
        });

        const store = getStore();
        const currentEvent = store.monitoring.currentEvent;
        const newEvent = {
            ...currentEvent,
            markets: currentEvent.markets.map(market => {
                if (market.id !== data.marketId) return market;
                else return { ...market, maxWinAmount: data.maxWinAmount };
            }),
        };

        dispatch(setCurrentEvent(newEvent));
    } else {
        notification.error({
            message: 'Max Win Amount Change Failed!',
        });
    }
};

export const changeEventHistory = (isVisible, eventId) => ({
    type: MONITORING_EVENT_HISTORY_CHANGED,
    payload: {
        eventId,
        isVisible,
    },
});

export const getEventHistory = params => async dispatch => {
    const data = await MonitoringService.getEventHistory(params);

    if (data?.items) {
        dispatch(setEventHistory(data.items));
    }
};

export const changeEventRiskDetails = (isVisible, eventId, type) => ({
    type: MONITORING_RISK_DETAILS_CHANGED,
    payload: {
        eventId,
        isVisible,
        type,
    },
});

export const getEventRiskValues = params => async dispatch => {
    const data = await MonitoringService.getEventRiskValues(params);

    if (data?.items) {
        dispatch(setEventRiskDetails(data.items));
    }
};

export const changeBetInformation = data => ({
    type: MONITORING_BET_INFORMATION_CHANGED,
    payload: {
        ...data,
    },
});

export const getEventTickets = filters => async dispatch => {
    const data = await MonitoringService.getEventTickets(filters);

    if (data?.items) {
        dispatch(setBetInformation(data.items));
    }
};

const getNewEventListAfterAction = ({ events, eventId, tournamentId, fieldKey, fieldValue }) => {
    return events.map(tournament => {
        if (tournament.id !== tournamentId) return tournament;
        else
            return {
                ...tournament,
                events: tournament.events.map(event => {
                    if (event.id !== eventId) return event;
                    else
                        return {
                            ...event,
                            [fieldKey]: fieldValue,
                        };
                }),
            };
    });
};

const getNewOutrightEventListAfterAction = ({ events, eventId, changedFields }) => {
    return events.map(event => {
        if (event.id !== eventId) return event;

        return {
            ...event,
            ...changedFields,
        };
    });
};

export const fetchSettlementHistory = params => async (dispatch, getStore) => {
    dispatch(setSettlementFetching(true));

    const { info, items: data } = await MonitoringService.getSettlementTickets(params);
    if (!info.success) {
        dispatch(setSettlementFetching(false));
        // dispatch(changeMainPaginationProps({ hasMore: false }));
        return;
    }

    const store = getStore();
    const currentData = store.monitoring.settlementHistory.data;

    let newData = [];

    if (params.pageIndex > 0) {
        newData = currentData.concat(data);
    } else {
        newData = data;
    }

    if (data.length < params.pageSize) {
        // dispatch(changeMainPaginationProps({ hasMore: false }));
    } else {
        // dispatch(changeMainPaginationProps({ hasMore: true }));
    }

    dispatch(setSettlement(newData));

    return data;
};

export const fetchMarketData = params => async dispatch => {
    dispatch(setMarketFetching(true));

    const data = await MonitoringService.getSettlementMarkets(params);

    if (data.item) {
        dispatch(
            setMarketData({
                params,
                ...data.item,
            }),
        );
    }

    dispatch(setMarketFetching(false));
};

export const setMarketData = event => ({
    type: MARKET_DATA_CHANGED,
    payload: event,
});

export const clearfetchMarketData = () => ({
    type: MARKET_DATA_CLEARED,
});

export const saveMarketsFilters = marketFilters => ({
    type: MARKETS_FILTERS_CHANGED,
    payload: marketFilters,
});

export const setSelectedSportId = sportId => ({
    type: MONITORING_SET_SELECTED_SPORTID,
    payload: sportId,
});

export const setMonitoringSports = payload => ({
    type: MONITORING_SPORTS_RECEIVED,
    payload,
});

export const setMonitoringDates = payload => ({
    type: MONITORING_DATES_CHANGED,
    payload,
});

export const setEventHistory = payload => ({
    type: MONITORING_EVENT_HISTORY_RECEIVED,
    payload,
});

export const setEventRiskDetails = payload => ({
    type: MONITORING_RISK_DETAILS_RECEIVED,
    payload,
});

export const setBetInformation = payload => ({
    type: MONITORING_BET_INFORMATION_RECEIVED,
    payload,
});

export const setSettlementFetching = payload => ({
    type: SETTLEMENT_FETCHING_CHANGED,
    payload,
});

export const setSettlement = payload => ({
    type: SETTLEMENT_CHANGED,
    payload,
});

export const setMarketFetching = payload => ({
    type: MARKET_FETCHING_CHANGED,
    payload,
});

export const setMonitoringEvents = payload => ({
    type: MONITORING_EVENTS_RECEIVED,
    payload,
});

export const setMonitoringOutrightEvents = payload => ({
    type: MONITORING_OUTRIGHT_EVENTS_RECEIVED,
    payload,
});

export const updateMonitoringEvents = payload => ({
    type: MONITORING_EVENTS_UPDATED,
    payload,
});

export const updateMonitoringOutrightEvents = payload => ({
    type: MONITORING_OUTRIGHT_EVENTS_UPDATED,
    payload,
});
